import { I18nLocale } from '../models/Base';
import { Space } from '../models/SpaceStore/Space';
import { SpaceMembership } from '../models/SpaceStore/SpaceMembership';

export const getContentLocale = (
  classroom?: Space | null,
  membership?: SpaceMembership | null,
): I18nLocale | undefined => {
  const isMultiLang: boolean = classroom?.isMultiLang ?? false;
  return isMultiLang ? undefined : membership?.preferredWritingSystem;
};

export const getSpokenLocale = (
  classroom?: Space | null,
  membership?: SpaceMembership | null,
): I18nLocale | undefined => {
  const isMultiLang: boolean = classroom?.isMultiLang ?? false;
  const spokenLocale = membership?.preferredSpeakingAccent;
  const contentLocale = getContentLocale(classroom, membership);
  const useSpokenLocale: boolean = contentLocale?.startsWith('zh') ?? false;
  return isMultiLang
    ? undefined
    : useSpokenLocale
    ? spokenLocale
    : contentLocale;
};
